/**
 * App-wide "busy" state for uploads and downloads, shown as one overlay in the
 * centre of the screen (GlobalLoadingOverlay) instead of spinners on buttons.
 *
 * Plain module state, not React context, so the axios instance (services/api.js)
 * can report network uploads/downloads without a component in between. Several
 * tasks may overlap; the overlay shows the most recent one and stays up until
 * all have ended.
 *
 *   const id = startLoading('Preparing download…');
 *   updateLoading(id, { progress: 40 });
 *   endLoading(id);
 */
let nextId = 1;
const tasks = new Map(); // id -> { message, progress }
const listeners = new Set();
let snapshot = null;

const emit = () => {
  const last = [...tasks.values()].pop();
  snapshot = last ? { ...last } : null;
  listeners.forEach((fn) => fn());
};

export const startLoading = (message = 'Please wait…', progress = null) => {
  const id = nextId++;
  tasks.set(id, { message, progress });
  emit();
  return id;
};

export const updateLoading = (id, patch) => {
  if (!tasks.has(id)) return;
  tasks.set(id, { ...tasks.get(id), ...patch });
  emit();
};

export const endLoading = (id) => {
  if (tasks.delete(id)) emit();
};

export const subscribeLoading = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getLoadingSnapshot = () => snapshot;
